export enum OrderType {
	LOCAL = "LOCAL",
	PICKUP = "LLEVAR",
	DELIVERY = "DELIVERY",
}
